




import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class SearchFilterComponent extends Vue {
    @Prop(String)
    value!: string;

    @Prop(String)
    size!: string | undefined;

    @Prop(String)
    minDate: string | undefined;

    @Prop(String)
    maxDate: string | undefined;

    @Prop(String)
    position: string | undefined;

    get internalDate() {
        return this.parseDateString(this.value);
    }

    set internalDate(value: any) {
        this.$emit("input", this.parseToStringForQuery(value));
    }

    get internalMinDate() {
        return this.parseDateString(this.minDate as string);
    }

    get internalMaxDate() {
        return this.parseDateString(this.maxDate as string);
    }

    parseToStringForQuery(dateString: string) {
        const date = this.parseDateString(dateString);

        if (date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        }

        return "";
    }

    parseDateString(dateString: string) {
        const date = Date.parse(dateString);

        // Check if date is valid and return if true
        if (!isNaN(date)) {
            return new Date(date);
        }

        return null;
    }
}
